import { Component } from "react";
import { AuthState } from "@aws-amplify/ui-components";
import "../form_business_partner/resp.css";
import { MenuDrawer } from "../main_components/menu/PermanentMenu";
import { CssBaseline } from "@material-ui/core";
import LoginPage from "./config/loginPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Actualizado
import routes from "./config/routes";
import { extractStructuredData, parsData, findInObject } from "./verify_role";

export class index extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.AuthState === AuthState.SignedIn) {
      sessionStorage.setItem(
        "getAccesTokenRefresh",
        this?.props?.User?.["signInUserSession"]?.["accessToken"]?.["jwtToken"]
      );
      sessionStorage.setItem(
        "getIdTokenRefresh",
        this?.props?.User?.["signInUserSession"]?.["idToken"]?.["jwtToken"]
      );
      sessionStorage.setItem(
        "id_user",
        this?.props?.User?.["attributes"]?.["custom:id_user"]
      );
      sessionStorage.setItem(
        "roles_user",
        this?.props?.User?.["attributes"]?.["custom:roles"]
      );
      sessionStorage.setItem(
        "email_uset",
        this?.props?.User?.["attributes"]?.["email"]
      );
      // sessionStorage.setItem(
      //   "email_user_c                                                                                                                                                                                                                                                                                                                                                                                                                                                                       ",
      //   this?.props?.User?.["attributes"]?.["email"]
      // );    
      console.log(this?.props?.User?.["attributes"]?.["email"]);

      sessionStorage.setItem(
        "email_user",
        this?.props?.User?.["attributes"]?.["email"]
      );

      // const roles = getUserRoles(
      //   this?.props?.User?.["attributes"]?.["custom:roles"]
      // );

      // console.log(roles);

      var permisosUsuario = this?.props?.User?.["attributes"]?.["custom:roles"];
      var permisoUsuarioReplace = permisosUsuario?.replace(/ /g, "");
      var permisos = permisoUsuarioReplace?.split(";");

      //sessionStorage.setItem("user_roles_data", permisos);

      const res = extractStructuredData(permisos);
      const n_res = parsData(res);
      sessionStorage.setItem("user_roles_data", JSON.stringify(n_res));

      const onSideBarStatic = () => {
        const sidebar = document.getElementById("tc");
        if (sidebar && sidebar.style) {
          sidebar.style.width = "calc(100% - 220px)";
          sidebar.style.left = "200px";
          sidebar.style.right = "20px";
        }
      };

      const onSideBarNoStatic = () => {
        const sidebar = document.getElementById("tc");
        if (sidebar && sidebar.style) {
          sidebar.style.width = "calc(100% - 105px)";
          sidebar.style.left = "85px";
          sidebar.style.right = "20px";
        }
      };

      const onSideBarHide = () => {
        const sidebar = document.getElementById("tc");
        if (sidebar && sidebar.style) {
          sidebar.style.width = "100%";
          sidebar.style.left = "1%";
          sidebar.style.right = "1%";
        }
      };

      const closeSession = () => {
        this.props.SetAuthState(AuthState.SignedOut);
      };

      const userEmail = this?.props?.User?.["attributes"]?.["email"];
      const userId = this?.props?.User?.["attributes"]?.["custom:id_user"];
      const name = this?.props?.User?.["attributes"]?.["name"];

      localStorage.setItem("user_name", name);

      return (
        <>
          <CssBaseline />

          {
            <div id="tc" className="tc">
              {this.props.User === null ? (
                <div> Loading User </div>
              ) : (
                <Router>
                  <MenuDrawer
                    closeSession={closeSession}
                    userEmail={userEmail}
                    userId={userId}
                    onSideBarHide={onSideBarHide}
                    onSideBarStatic={onSideBarStatic}
                    onSideBarNoStatic={onSideBarNoStatic}
                    ROLES={n_res}
                  />
                  <div className="tc w-100">
                    <Routes>
                      {routes.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={<route.component />} // Actualizado
                        />
                      ))}
                    </Routes>
                  </div>
                </Router>
              )}
            </div>
          }
        </>
      );
    } else {
      return <LoginPage SetAuthState={this.props.SetAuthState}></LoginPage>;
    }
  }
}

export default index;
